/// <reference path="../_all.ts" />

module library {
  'use strict';

  LibraryImageResizeDirective.$inject = [
      '$timeout',
      '$location',
      'libraryDimensionService',
      'pageMetaService',
  ];


  export function LibraryImageResizeDirective(
       $timeout: ng.ITimeoutService,
       $location: ng.ILocationService,
       libraryDimensionService: ILibraryDimensionService,
       pageMetaService: navigation.IPageMetaService
      ): ng.IDirective {


    return {
      restrict: 'E',
      scope: {
        data: '=libraryData',
      },
      templateUrl: 'library/LibraryImageResizeDirective',
      link: function (scope: ILibraryImageResizeDirectiveScope, element: ng.IAugmentedJQuery, attr: ng.IAttributes) {

        scope.meta = pageMetaService.getPageMeta;

        scope.advancedDetails = false;
        scope.RevId = $location.search()['revid'];
        scope.dimensions = { x: 0, y: 0 };
        scope.input = { x: 0, y: 0 };

        scope.megaPixelLimit = 0;
        scope.maxDimensions = { x: 0, y: 0 };


        scope.Zentimeter = { x: 0, y: 0 };
        scope.Inch = { x: 0, y: 0 };
        scope.Pixel = { x: 0, y: 0 };
        scope.dpi = 0;

        scope.ONEINCH = 2.54;

        scope.quality = { web: 0, mail: 0, druck: 0, plakat: 0, plakata1: 0 };

        scope.$watch('data.Revision', (newVal, oldVal) => {
          if (newVal != null) {
            scope.getDimensions();
            scope.getPictureTemplateList();
          }
        })

        scope.$watch('unit', (newVal, oldVal) => {
          if (newVal !== oldVal) { scope.update(); };
        });

        scope.$watch('dpi', (newVal: string, oldVal: string) => {
          if (newVal !== oldVal) {
            var parsed = parseFloat(newVal);
            if (newVal === '' || isNaN(parsed) || parsed < 10) return;

            var x = scope.input.x;
            if (scope.unit == 'cm') { x = scope.input.x * scope.dpi / scope.ONEINCH; }
            if (scope.unit == 'in') { x = scope.input.x * scope.dpi; }

            scope.setPixelX(x);
            scope.setPixelY(x / scope.dimensions.x * scope.dimensions.y);

            scope.update();
          };
        });

        scope.$watch('input.x', (newVal: string, oldVal: string) => {
          if (newVal !== oldVal) {
            var parsed = parseFloat(newVal);
            if (newVal === '' || isNaN(parsed) || parsed < 1) return;

            var xRaw = scope.input.x,
              xInch = xRaw
              , xPx;

            if (scope.unit == 'cm') { xInch = xRaw / scope.ONEINCH; } else { xInch = xRaw; }

            if (scope.unit != 'px') {
              xPx = Math.round(xInch * scope.dpi);
              if (xPx > scope.dimensions.x) {
                scope.dpi = Math.round(scope.dimensions.x / xInch);
              }
            } else {
              xPx = xRaw; //pixel as input
            }

            scope.setPixelX(xPx);
            scope.setPixelY(xPx / scope.dimensions.x * scope.dimensions.y);

            scope.update();
          }
        });

        scope.$watch('input.y', (newVal: string, oldVal: string) => {
          if (newVal !== oldVal) {
            var parsed = parseFloat(newVal);
            if (newVal === '' || isNaN(parsed) || parsed < 1) return;

            var yRaw = scope.input.y,
              yInch = yRaw
              , yPx;

            if (scope.unit == 'cm') { yInch = yRaw / scope.ONEINCH; }

            if (scope.unit != 'px') {
              yPx = Math.round(yInch * scope.dpi);
              if (yPx > scope.dimensions.y) {
                scope.dpi = Math.round(scope.dimensions.y / yInch);
              }
            } else {
              yPx = yRaw; //pixel as input
            }

            scope.setPixelY(yPx);
            scope.setPixelX(yPx / scope.dimensions.y * scope.dimensions.x);

            scope.update();
          }
        });

        scope.QAL_SYMBOL = ['--', '-', 'o', '+', '++'];
        scope.QAL_COLOR = ['#00BF00', '#FFC000', '#BF0000'];

        scope.qualFunctions = {
          Web: (x, y, dpi) => {
            return x * y / 1000000 < 0.4 ? 0 :
                   x * y / 1000000 < 1.1 ? 1 : 2;
          }
          , Mail: (x, y, dpi) => {
            return x * y / 1000000 < 0.4 ? -1 :
                   x * y / 1000000 < 1.8 ? 0 :
                   x * y / 1000000 < 2.6 ? 1 : 2;
          }
          , Druck: (x, y, dpi) => {
            return dpi < 150 ? -2 :
                   dpi < 300 ? -1 : 0
          }
          , Plakat: (x, y, dpi) => {
            return dpi < 150 ? -1 : 0;
          }
          , PlakatA1: (x, y, dpi) => {
            return dpi < 75 ? -1 : 0;
          }
        }

        scope.qualTooltips = {
          "++": () => {
            return (scope.meta('hl') == 'D') ? "Bild zu gross" : "Image too big";
          }
          , "+": () => {
            return (scope.meta('hl') == 'D') ? "Bild eher zu gross" : "Image rather too big";
          }
          , "o": () => {
            return (scope.meta('hl') == 'D') ? "Ideal" : "Perfect";
          }
          , "-": () => {
            return (scope.meta('hl') == 'D') ? "Bild eher zu klein" : "Image rather too small";
          }
          , "--": () => {
            return (scope.meta('hl') == 'D') ? "Bild zu klein" : "Image too small";
          }
        }


        scope.getDimensions = () => {
          if (scope.data.Revision && scope.data.Revision.DocumentRevDestID) { 
            libraryDimensionService.getDimensions(scope.data.Revision.DocumentRevDestID).then((response) => {
              scope.dimensions = response.data;
              scope.applyTemplate();
            })
          }
        }

        scope.getPictureTemplateList = () => {
          if (scope.meta('hl') != null) {
            libraryDimensionService.getPictureTemplateList(scope.meta('hl')).then((response) => {
              scope.templates = response.data;
              // resolve max megapixel limit
              scope.megaPixelLimit = 0;
              scope.templates.forEach( (el, i, arr) => {
                if (el.megapixel < 0) scope.megaPixelLimit = 99999;
                scope.megaPixelLimit = Math.max(el.megapixel, scope.megaPixelLimit);
              });
              scope.selectedtemplate = response.data[0]; // "{"description":"Mail","megapixel":1.1,"sizeUnit":"px","dpi":72}"

              scope.applyTemplate();
            })
          }
        }

        var requests : { [ id : string ] : ng.IPromise<string[]> } = {};

        scope.getImageURL = (revisionid, x, y)  => {

          if (revisionid != null && x != null && y != null) {
            var hash = revisionid + '-' + x + '-' + y;

            if (requests[hash] == null) {
              requests[hash] = libraryDimensionService.getImageURL(revisionid, x, y);
            }
            
            requests[hash].then((data: string[]) => {
              scope.previewlink = data[0];
              scope.downloadlink = data[1];
            }).finally(()=>{
              requests[hash] = null;
            });

          }
        }

        scope.applyTemplate = ()  => {
          if (scope.dimensions == null) return;
          if ((scope.dimensions.x == 0 && scope.dimensions.y == 0) || scope.selectedtemplate == null) return;
          scope.unit = scope.selectedtemplate.sizeUnit;

          var mPixOrig = scope.dimensions.x * scope.dimensions.y;

          var faktorMax = Math.sqrt(mPixOrig / (scope.megaPixelLimit * 1000000));
          scope.maxDimensions.x = Math.round(scope.dimensions.x / faktorMax);
          scope.maxDimensions.y = Math.round(scope.dimensions.y / faktorMax);

          var mpix = scope.selectedtemplate.megapixel;
          if (mpix < 0) mpix = 9999;

          var faktor = Math.sqrt(mPixOrig / (mpix * 1000000));
          var x = Math.round(scope.dimensions.x / faktor);
          var y = Math.round(scope.dimensions.y / faktor);

          scope.Pixel.x = Math.min(x, scope.dimensions.x, scope.maxDimensions.x);
          scope.Pixel.y = Math.min(y, scope.dimensions.y, scope.maxDimensions.y);

          scope.dpi = scope.selectedtemplate.dpi;

          scope.update();
        };

        scope.update = ()  => {
          scope.previewlink = '';
          scope.downloadlink = '';

          scope.Zentimeter.x = scope.Pixel.x / scope.dpi * scope.ONEINCH;
          scope.Zentimeter.y = scope.Pixel.y / scope.dpi * scope.ONEINCH;
          scope.Inch.x = scope.Pixel.x / scope.dpi;
          scope.Inch.y = scope.Pixel.y / scope.dpi;

          var d;
          if (scope.unit == 'px') { d = scope.Pixel; }
          if (scope.unit == 'cm') { d = scope.Zentimeter; }
          if (scope.unit == 'in') { d = scope.Inch; }

          scope.input.x = parseFloat(d.x.toFixed(2));
          scope.input.y = parseFloat(d.y.toFixed(2));

          if (scope.Pixel.x > 0) {
            scope.getImageURL(scope.data.Revision.DocumentRevDestID, scope.Pixel.x, scope.Pixel.y);
          }
        };

    
        scope.preview = ($event)  => {
            $event.preventDefault();

            if (scope.previewlink != "" && scope.previewlink != "#") {
              var w = 800;
              var h = 600;
              var options = 'menubar=no,scrollbars=yes,resizable=yes,width=' + w + ',height=' + h + ',left=' + ((screen.width - w) / 2) + ',top=' + ((screen.height - h) / 2);

              var win = window.open('', 'PopupWindow', options);
              if (window.focus) { win.focus(); }
              win.document.open();
              win.document.write('<head><title>Preview</title></head>');
              win.document.write('<body style="margin: 0; padding: 0;"><img src="' + scope.previewlink + '" alt="Vorschau" />');
              win.document.write('</body></html>');
              win.document.close();
            }
        }

        scope.setPixelX = (x)  => {
          scope.Pixel.x = Math.round(Math.min(x, scope.dimensions.x, scope.maxDimensions.x));
        }
        scope.setPixelY = (y)  => {
          scope.Pixel.y = Math.round(Math.min(y, scope.dimensions.y, scope.maxDimensions.y));
        }

        scope.getDownloadSizeEst = ()  => {
          return scope.Pixel.x * scope.Pixel.y * 24 / 8 / 10; //if picture hat compression ration of 1:10
        };

        scope.getDownloadtimeEst = ()  => {
          return scope.Pixel.x * scope.Pixel.y * 24 / 10 / 1024 / 1024 / 15; //15 Mbit/s
        };

        scope.getDownloadtimeMobileEst = ()  => {
          return scope.Pixel.x * scope.Pixel.y * 24 / 10 / 1024 / 1024; //1 MBit/s/s
        };

        scope.getQualityTooltip = (symbol)  => {
          return scope.qualTooltips[symbol]();
        }

        scope.getQualityRating = (type)  => {
          if (scope.Pixel.x != null) {
            var q: number = scope.qualFunctions[type](scope.Pixel.x, scope.Pixel.y, scope.dpi);
            return scope.QAL_SYMBOL[q + 2];
          }
        }

        scope.getQualityColor = (type)  => {
          if (scope.Pixel.x != null) {
            var q: number = scope.qualFunctions[type](scope.Pixel.x, scope.Pixel.y, scope.dpi);
            return { color: scope.QAL_COLOR[Math.abs(q)] };
          }
        }


      }
    }
  }

}